__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "infoins-frontend-auth-module";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@infoins-v5/ui", "1.0.46", () => (Promise.all([__webpack_require__.e(362), __webpack_require__.e(786), __webpack_require__.e(9224), __webpack_require__.e(1527), __webpack_require__.e(3684), __webpack_require__.e(5929), __webpack_require__.e(6666)]).then(() => (() => (__webpack_require__(9224))))));
			register("dayjs", "1.11.23", () => (() => (__webpack_require__(74353))), 1);
			register("framer-motion", "11.18.2", () => (Promise.all([__webpack_require__.e(157), __webpack_require__.e(1527), __webpack_require__.e(2467)]).then(() => (() => (__webpack_require__(10157))))));
			register("framer-motion", "12.43.0", () => (Promise.all([__webpack_require__.e(6840), __webpack_require__.e(1527), __webpack_require__.e(7095)]).then(() => (() => (__webpack_require__(86840))))));
			register("i18next", "25.10.10", () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(72635))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(32389))))));
			register("react-promise-tracker", "2.1.1", () => (Promise.all([__webpack_require__.e(4601), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(54601))))));
			register("react-redux", "9.3.0", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(71468))))));
			register("react-router-dom", "7.18.3", () => (Promise.all([__webpack_require__.e(1046), __webpack_require__.e(1527), __webpack_require__.e(5929)]).then(() => (() => (__webpack_require__(91046))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};